module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="datepicker-wrap J_datepicker-wrap">\r\n   <ul class="candidate-list">\r\n       <!--li class="candidate-item" date-format="YYYYMMDD">{{YYYYMMDD}}</li>\r\n       <li class="candidate-item" date-format="YYYY-MM-DD">{{YYYY-MM-DD}}</li>\r\n       <li class="candidate-item" date-format="YYYY/MM/DD">{{YYYY/MM/DD}}</li>\r\n       <li class="candidate-item" date-format="YYYY年MM月DD日">{{YYYY年MM月DD日}}</li-->\r\n       <li class="candidate-item" date-format="YYYY年MM月DD日 hh:mm">{{YYYY-MM-DD hh:mm}}</li>\r\n   </ul>\r\n    <button class="cancel">取消</button>\r\n</div>';

}
return __p
}